import * as yup from "yup";

export const contactSchema = yup.object().shape({
  name: yup
    .string()
    .required()
    .label("Name")
    .default("")
    .transform((value) => value ?? ""),
  email: yup
    .string()
    .email()
    .label("Email")
    .default("")
    .transform((value) => value ?? ""),
  phone: yup
    .string()
    .label("Phone")
    .default("")
    .transform((value) => value ?? ""),
  note: yup
    .string()
    .label("Note")
    .default("")
    .transform((value) => value ?? ""),
});
